export const PaymentUrl = {
  // Payment
  // create
  create: '/PreReserve/PaymentCommand/CreatePayment',
  // verify
  verify: '/PreReserve/PaymentCommand/VerifyPayment',
  // Get Payments By PreReserve Id
  GetByPreReserveId: '/PreReserve/PaymentQuery/GetPaymentsByPreReserveId',
}
